"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSignalBand = exports.SIGNAL_FAIR_DBM = exports.SIGNAL_GOOD_DBM = void 0;
exports.SIGNAL_GOOD_DBM = -95;
exports.SIGNAL_FAIR_DBM = -105;
const getSignalBand = (rssi) => rssi >= exports.SIGNAL_GOOD_DBM ? 'good' : rssi >= exports.SIGNAL_FAIR_DBM ? 'fair' : 'poor';
exports.getSignalBand = getSignalBand;
